<div class="card form-card" style="min-height: 420px;">
	<div class="card-body">
		<div class="section-title">
			<i class="bi bi-person-circle"></i>
			User Information
		</div>

		<div class="row g-3">
			<!-- Institute ID -->
			<!-- <div class="col-md-6" *ngIf="!loading && institutes && institutes.length>0" [class.disabled-div]="user.user_name !== 'sa'">
				<label class="form-label">
					Institute ID
					<span class="required" *ngIf="user.user_name == 'sa'">*</span>
				</label>
				<select class="form-select" [(ngModel)]="frmData.inst_id">
					<option selected disabled>
						Select Institute
					</option>
					@for(ins of institutes; track $index) {
						<option value="{{ins.id}}">{{ins.id}}-{{ins.inst_name}}</option>
					}
				</select>
			</div> -->
			<!-- Display Name -->
			<div class="col-md-4">
				<label class="form-label">
					ERP Key Code
					<span class="required">*</span>
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.erp_key" 
					placeholder="Enter ERP Code" [disabled]="user.user_role[0].code != 'spr'">
			</div>

			<!-- Roles -->
			<div class="col-md-8">
				<label class="form-label">
					Select Role
					<span class="required">*</span>
				</label>
				<ng-multiselect-dropdown
					[placeholder]="'Select Role'"
					[settings]="dropdownSettings"
					[data]="dropdownList"
					[(ngModel)]="frmData.user_role"
					data-boundary="viewport">
				</ng-multiselect-dropdown>
			</div>

			<!-- <div class="col-md-6">
				<label class="form-label">
					Mobile No.
					<span class="required">*</span>
				</label>
				<input type="tel" class="form-control" [(ngModel)]="frmData.mobile_no" 
					placeholder="Enter Mobile No" maxlength="10" pattern="[0-9]">
			</div> -->

			<ng-container *ngIf="!frmData.id">
				<!-- Username -->
				<div class="col-md-6">
					<label class="form-label">
						Username
						<span class="required">*</span>
					</label>
					<input type="text" class="form-control" [(ngModel)]="frmData.user_name" 
						placeholder="Enter Username">
				</div>

				<!-- Password -->
				<div class="col-md-6">
					<label class="form-label">
						Password
						<span class="required">*</span>
					</label>

					<div class="input-group">
						<span class="input-group-text">
							<i class="bi bi-lock"></i>
						</span>

						<input type="password" class="form-control" [(ngModel)]="newPassword" 
							placeholder="Enter Password">
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="frmData.id">
				<!-- Username -->
				<div class="col-md-4">
					<label class="form-label">
						Username
						<span class="required">*</span>
					</label>
					<input type="text" class="form-control" [(ngModel)]="frmData.user_name" 
						placeholder="Enter Username">
				</div>
			</ng-container>

			<div class="col-md-4">
				<label class="form-label">
					Staff Member
				</label>
				<select class="form-select" [(ngModel)]="frmData.emp_code"
					[disabled]="frmData.erp_key != user.erp_key">
					<option value="">--</option>
					@for (a of staff(); track a) { <option [value]="a.emp_code" [selected]="frmData.emp_code==a.emp_code">{{ a.first_name }} {{ a.last_name }} ({{ dataService.getDeptName(a.department) }})</option> }
				</select>
			</div>

			<!-- Display Name -->
			<div class="col-md-5">
				<label class="form-label">
					Display Name
					<span class="required">*</span>
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.display_name" 
					placeholder="Enter Display Name">
			</div>

			<!-- Active Status -->
			<div class="col-md-3" *ngIf="user.user_role[0].code == 'spr' || user.user_role[0].code == 'adm'">
				<label class="form-label">
					Is Active
					<span class="required">*</span>
				</label>

				<select class="form-select form-control" [(ngModel)]="frmData.is_active">
					<option selected disabled>
						Select Status
					</option>
					<option value="true">Yes</option>
					<option value="false">No</option>
				</select>
			</div>
		</div>

		<!-- <div class="info-box mt-3 d-flex">
			<i class="bi bi-info-circle me-2"></i>
			<span>Select one or more roles using Ctrl + Click (Windows) or Cmd + Click (Mac).</span>
		</div> -->

	</div>
</div>